import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { Progress, Card, CardBody } from 'reactstrap';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, ComposedChart, Text, LabelList } from 'recharts';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import getTooltipStyles from '../../../../shared/helpers';
import Panel from '../../../../shared/components/Panel';
import StatIcon from 'mdi-react/MapSearchOutlineIcon';

import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_getBuildingURL,
} from '../../../../shared/helpers/utils';
import{
	_axiosCall,
} from '../../../../shared/helpers/apicalls';
import { getDefaultChartColors } from '../../../../shared/helpers';



const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value } = props;
  const radius = 10;

  return (
    <g>
      <text x={x + width / 2} y={y - radius} fill="#780F9E" textAnchor="middle" dominantBaseline="middle">
        {value === 0 ? 'N/A' : _formatNumber(value)}
      </text>
    </g>
  );
}

const colors = {
	shadow: "#858AA1",
	active: "#4ce1b6",
	contract: "#B070CC",
	sold: "#D6BAE8",
	recorded: "#FF206E",
	resale: "#28C2FF",
	unsold: "#780F9E"
}

const CustomizedAxisTick = ( {x, y, stroke, payload} ) => {
		
   	return (
    	<g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-45)">{_capitalizeText(payload.value)}</text>
      </g>
    );
}

const svgToPng = (svg, width, height) => {
    return new Promise((resolve, reject) => {

      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext('2d');

      // Set background to white
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);

      let xml = new XMLSerializer().serializeToString(svg);
      let dataUrl = 'data:image/svg+xml;utf8,' + encodeURIComponent(xml);
      let img = new Image(width, height);

      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        let imageData = canvas.toDataURL('image/png', 1.0);

        resolve(imageData)
      }

      img.onerror = () => reject();

      img.src = dataUrl;
    });
};

class NeighborhoodAnalysis extends PureComponent {
    
  constructor() {
    super();
    
  }
  currentChart;
  
  _constructNeighborhoodData = (facetData) => {
	  
	const neighborhoods = facetData.by_neighborhood.buckets; 
	
	const data = [];
	
	neighborhoods.map(hood => {
		
		const count = hood.total_inventory;
		const active = hood.total_inventory_active;
		const Contract = hood.total_inventory_contract;
		const Sold = hood.total_inventory_sold + hood.total_inventory_not_yet_recorded;
		const resale = hood.total_inventory_resale;
		const total_not_yet_recorded = hood.total_inventory_not_yet_recorded;
		const Unsold = hood.total_inventory_unsold;
		const shadow = count - (active + Contract + Sold + resale);
		
	
 	  	
 	  	const all_sold = count - Contract - Unsold;
 	  	const hoodData = {
	 	  	name: hood.val,
	 	  	count,
	 	  	shadow,
	 	  	active,
	 	  	Contract,
	 	  	Sold,
	 	  	resale,
	 	  	Unsold,
	 	  	all_sold
 	  	}
 	  	
 	  	data.push(hoodData);	
 	  	
 	  	data.sort((a, b) => (a.Unsold > b.Unsold ? -1 : 1));  	
		
	})
	return data; 
    
  }
  
  handleClick(data, index) {
  	const { history } = this.props;
  	
  	console.log(history);
  	if(history && history.location.search.indexOf("searchText") >=0 ){
	  	const newSearch = history.location.search.replace(/(searchText=).*?(&)/,'$1' + data.name + '$2');
	  	history.push(`/building-database/sale${newSearch}`);
	  	
  	}else{
	  	
	  	if(history.location.search.indexOf("?")>=0){
		  	let newSearch = history.location.search + '&' + 'searchText=' + data.name;
		  	history.push(`/building-database/sale${newSearch}`);
	  	}else{
		  	let newSearch = history.location.search + '?' + 'searchText=' + data.name;
		  	history.push(`/building-database/sale${newSearch}`);
	  	}
  	}
  	
  }
  
  handleDownload = async () => {
	  
	return false;
    const chart = this.currentChart

    let chartSVG = ReactDOM.findDOMNode(chart).children[0]

    const pngData = await svgToPng(chartSVG, 1200, 1600)
    document.write('<img src="'+pngData+'"/>') // <------
  }
 

  
  render() {
      const { facetData } = this.props;    
      if(!facetData){
	    return null;
      }
      
      const data = this._constructNeighborhoodData( facetData );

	  return (
	  	<Card>
		    <CardBody className="dashboard__booking-card">
		      <div className="dashboard__booking-total-container">
	          	<h5 className="dashboard__booking-total-description">Neighborhoods With Most Unsold Inventory</h5>
			  	<StatIcon className="dashboard__trend-icon" onClick={() => this.handleDownload()} />
	          </div>
		      <ResponsiveContainer  height={400} className="dashboard__area">
		        <BarChart ref={(chart) => this.currentChart = chart} data={data} margin={{ top: 50, left: -20, bottom: 20, right:20 }}>
			       
		           <XAxis dataKey="name" interval={0} tickLine={false} reversed={false} tick={<CustomizedAxisTick/>} height={60} />				
			       <YAxis  yAxisId="left" tickLine={true} orientation={'left'} tickFormatter={value => [new Intl.NumberFormat('en').format(value)].join('')} />
			       <Tooltip formatter={(value, name, props) => ( _formatNumber(value) )} labelFormatter={(value) => `${_capitalizeText(value)}`} cursor={{ stroke: '#780F9E', strokeWidth: 1 }}/>
			       <Legend />
			       <CartesianGrid vertical={false}/>
			       <Bar dataKey={"Unsold"} yAxisId="left" stackId="a" barSize={35} fill={colors['unsold']} onClick={this.handleClick.bind(this)} cursor="pointer">
			       		
			       </Bar>
			       <Bar dataKey={"Contract"} yAxisId="left" stackId="a" barSize={35} fill={colors['contract']} onClick={this.handleClick.bind(this)} cursor="pointer"/>
			       <Bar dataKey={"Sold"} yAxisId="left" stackId="a" barSize={35} fill={colors['sold']} onClick={this.handleClick.bind(this)} cursor="pointer" >
			       	 <LabelList dataKey="count" content={renderCustomizedLabel} />
			       </Bar>
			      </BarChart>
		      </ResponsiveContainer>
			 </CardBody>
		</Card>
		);
	}
}

export default NeighborhoodAnalysis;
